import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=d33c6d30&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=d33c6d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33c6d30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d33c6d30')) {
      api.createRecord('d33c6d30', component.options)
    } else {
      api.reload('d33c6d30', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=d33c6d30&scoped=true&", function () {
      api.rerender('d33c6d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YsjA50ARBAFA/JS/comp/PopupDialog.vue"
export default component.exports